import gql from 'graphql-tag';

const mutation = gql`
  mutation saveThematicsOverviewSettings($projectId: Int!, $settings: Json!, $thematicSelectionId: Int) {
    saveThematicsOverviewSettings(
      projectId: $projectId
      settings: $settings
      thematicSelectionId: $thematicSelectionId
    ) {
      settings
    }
  }
`;

export default mutation;
